// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"f170173a","564":"accdf866","955":"accdf866"}[chunkId] + ".chunk.css";
};